import React from "react";
import CustodyOrder from "../../../../components/cases/documents/custodyOder/CustodyOrder";
import AdviserDocsWrapper from "../../../../common/AdviserDocsWrapper";

const CustodyOrderPage = () => {
  return (
    <AdviserDocsWrapper pageName="Custody Order">
      <CustodyOrder />
    </AdviserDocsWrapper>
  );
};

export default CustodyOrderPage;
